import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route } from 'react-router-dom';
import { FlagsProvider } from 'flag';

import { CanonicalRoute, Footer, Header, RedirectWithStatus } from 'components';

import {
  BulkResize,
  PdfResize,
  PdfCompressor,
  Log,
  CompressImages,
  Contact,
  Help,
  ViewImage,
  ImageResize,
  NotFound,
  Privacy,
  TermsOfService,
  Delete
} from '..';

import CropImages from 'containers/Features/CropImages';
import PhotoEditor from 'containers/Features/PhotoEditor';
import PhotoCompress from 'containers/Features/PhotoCompress';

import withScrollToTop from 'hoc/withScrollToTop';
import { FEATURE_FLAGS } from 'constants/features';

// import global styles file
import './styles';

function renderBody({ render404 }) {

  if (render404) {
    return <NotFound />;
  }

  return (
    <Switch>
      <CanonicalRoute exact path='/' component={ ImageResize } />
      <CanonicalRoute exact path='/log' component={ Log } />
      <CanonicalRoute exact path='/bulk-resize' component={ BulkResize } />
      <CanonicalRoute exact path='/compress-images' component={ CompressImages } />
      <CanonicalRoute exact path='/pdf-resize' component={ PdfResize } />
      <CanonicalRoute exact path='/pdf-compressor' component={ PdfCompressor } />
      <CanonicalRoute exact path='/features/crop-photo' component={ CropImages } />
      <CanonicalRoute exact path='/features/photo-editor' component={ PhotoEditor } />
      <CanonicalRoute exact path='/features/compress-images' component={ PhotoCompress } />
      <CanonicalRoute exact path='/contact' component={ Contact } />
      <CanonicalRoute exact path='/help' component={ Help } />
      <CanonicalRoute exact path='/privacy' component={ Privacy } />
      <CanonicalRoute exact path='/terms-of-service' component={ TermsOfService } />
      <CanonicalRoute exact path='/image/:imageId' component={ ViewImage } />
      <CanonicalRoute exact path='/view/:imageId' component={ ViewImage } />
      <CanonicalRoute exact path='/edit/:imageId' component={ ImageResize } />
      <CanonicalRoute exact path='/del/:imageId' component={ Delete } />
      <RedirectWithStatus from='/features' to='/features/crop-photo' status={ 301 } />
      <RedirectWithStatus from='/Thumbnail/:id' to='/' status={ 301 } />
      <RedirectWithStatus from='/Output/:id' to='/' status={ 301 } />
      <Route component={ NotFound } />
    </Switch>
  );
}

const App = (props) => (
  <FlagsProvider flags={ FEATURE_FLAGS }>
    <Fragment>
      <Helmet>
        <title>Crop and Resize Images Online | ImageResize.org</title>
        <script type="text/javascript">{`
          window._urq = window._urq || [];
          _urq.push(['initSite', '0149e32c-c4f3-4b7a-bb30-bef8979d0977']);
          (function() {
            var ur = document.createElement('script'); ur.type = 'text/javascript'; ur.async = true;
            ur.src = ('https:' == document.location.protocol ? 'https://cdn.userreport.com/userreport.js' : 'http://cdn.userreport.com/userreport.js');
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ur, s);
          })();
        `}</script>
        <script async src="https://www.googletagmanager.com/gtag/js?id=UA-92539064-1"></script>
        <script>{`
          if(typeof gtag != "function") {
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            
            gtag('config', 'UA-92539064-1');
            
          }
        `}</script>
      </Helmet>
      <Header />
      { renderBody(props) }
      <Footer />
    </Fragment>
  </FlagsProvider>
);

export default withScrollToTop(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.jsx